import React from 'react';
import BottomNotification from '.';
import {useCurrentConversationActions} from '../../../../../utils/conversation';

export default function RequiresAssistanceNotification() {
  const {toggleRequiredAssistance} = useCurrentConversationActions();

  return (
    <BottomNotification
      color="danger"
      label="Remover de atender"
      onClick={() => {
        // Logic to remove the conversation from assistance
        console.log('Remove from assistance clicked');
        toggleRequiredAssistance();
      }}
    />
  );
}
